import { useEffect, useState } from "react";
import { useAppSelector } from "app/hooks";
import { useField } from "formik";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import ErrorMessage from "ui/atoms/ErrorMessage";

const FieldRadioGroup = ({ dataSource, name, label, subSectionId, onChangeCallback }: any) => {
  const [field, meta, helpers] = useField(name);
  const error = !!meta.error && meta.touched;
  const [fieldValue, setFieldValue] = useState<string>("");

  const { answers } = useAppSelector((state) => state.survey) ?? [];
  const id = name.split(".")[2];
  const answer =
    answers.find((answer) => answer.questionID === id && answer.subSectionId === subSectionId)?.value ?? "";

  const onChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(evt?.target?.value);
    onChangeCallback && onChangeCallback(evt?.target?.value as string);
  };

  useEffect(() => {
    if (fieldValue) {
      field.onChange({
        target: {
          name: name,
          value: fieldValue,
        },
      });
    }
  }, [fieldValue]);

  useEffect(() => {
    if (answer) {
      helpers.setValue(answer);
      setFieldValue(answer);
    }
  }, [answer]);

  if (!dataSource) return <></>;
  return (
    <Box sx={{ display: "flex" }}>
      <FormControl sx={{ marginTop: "1rem" }} error={error} required>
        <FormLabel id='demo-controlled-radio-buttons-group'>{label}</FormLabel>
        <RadioGroup
          row
          name={name}
          value={fieldValue}
          onChange={onChange}
          aria-labelledby='demo-controlled-radio-buttons-group'
        >
          {dataSource?.source?.map((item: any) => (
            <FormControlLabel key={item?.value} value={item?.value} control={<Radio />} label={item?.descripcion} />
          ))}
        </RadioGroup>
        <ErrorMessage>{meta?.touched && meta?.error}</ErrorMessage>
      </FormControl>
    </Box>
  );
};

export default FieldRadioGroup;
